export const isCorrectUrl = (urlParam: string | undefined): boolean => {
  if (urlParam) {
    try {
      new URL(urlParam);
      return true
    } catch (_) {
      return false
    }
  }  
  return false;
}